export default __webpack_public_path__ + "static/media/Inventory.5e059adf.png";